import { Tag } from 'antd'

import { patientSummaryShape } from '../prop-types'

export default function DiseasesTags({ patientSummary }) {
  return (
    <div>
      {patientSummary?.atrialFibrilationFlutterDisease && (
        <Tag color="orange">Atrial Fib./Flutter</Tag>
      )}
      {patientSummary?.anticoagulatedDisease && (
        <Tag color="magenta">Prophylaxis</Tag>
      )}
      {patientSummary?.prnAnticoagulatedDisease && (
        <Tag color="red">PRN Anticoagulation</Tag>
      )}
    </div>
  )
}

DiseasesTags.propTypes = {
  patientSummary: patientSummaryShape.isRequired,
}
